import React from 'react';
import { Link } from 'react-router-dom';

const Termsandprivacy = ({theme}) => {
    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4" style={{ color: theme ? '#f8f9fa' : 'black' }}>Terms of Service</h1>
            <p style={{  color: theme === "dark" ? "white" : "black" }}>
                Description for the Scholarship Platform:

                "Welcome to our Scholarship Platform, your gateway to a world of educational opportunities and financial support. Our platform is designed to connect students with a diverse range of scholarships tailored to their individual needs and ambitions.

                Whether you're a high school student planning your path to higher education, an undergraduate seeking financial assistance, or a graduate student pursuing advanced studies, our platform offers a comprehensive database of scholarship opportunities to explore.


            </p>
            <p style={{  color: theme === "dark" ? "white" : "black" }}>
                With our user-friendly interface, you can easily search for scholarships based on criteria such as academic achievements, field of study, extracurricular activities, and demographic background. We understand that each student is unique, which is why we strive to provide a wide array of scholarship options to accommodate diverse interests and circumstances.

                Beyond financial support, our platform also offers valuable resources to help students navigate the scholarship application process. From tips on writing compelling essays to guidance on securing recommendation letters, we're here to support you every step of the way.

                At our Scholarship Platform, we believe that education should be accessible to all, regardless of financial barriers. Join us today and embark on your journey to academic success!"
            </p>



                <h1 className="text-center mb-4" style={{ color: theme === "dark" ? "white" : "black"}}>Our Privacy Policy</h1>
                <p style={{  color: theme === "dark" ? "white" : "black"}}>
                    User Privacy Description:

                    "At our Scholarship Platform, we are committed to protecting your privacy and ensuring the security of your personal information. We understand the importance of maintaining the confidentiality of your data, and we adhere to strict privacy practices to safeguard your information.

                    When you use our platform to save your favorite scholarships, we only collect your email address for the sole purpose of providing you with personalized updates and notifications related to your saved scholarships. Your email address will not be used for any other purposes, and we will not share it with any third parties without your explicit consent.

                </p>
                <p style={{ color: theme === "dark" ? "white" : "black" }}>
                    We utilize industry-standard security measures to prevent unauthorized access, disclosure, or alteration of your email address. Our platform employs encryption protocols and secure storage systems to protect your information from cyber threats and unauthorized access.

                    Furthermore, we are committed to transparency and accountability regarding our data handling practices. Our Privacy Policy outlines our procedures for data collection, usage, and disclosure, ensuring that you have full visibility into how your information is being managed.

                    Your trust is paramount to us, and we take your privacy seriously. If you have any questions or concerns about our privacy practices or how your information is being handled, please don't hesitate to contact us. Thank you for entrusting us with your privacy as you explore and save scholarships on our platform."
                </p>
            <p>
                <Link to="/" className="btn btn" style={{ backgroundColor: theme === "dark" ? "white" : "black",color: theme === "dark" ? "black" : "white" }}>Back to Home</Link>
            </p>
            </div>


    );
};

export default Termsandprivacy;
